interface AppHeaderLogoProps {
  src: string;
  alt?: string;
}

export function AppHeaderLogo({ src, alt = 'Logo Espetos Grill' }: AppHeaderLogoProps) {
  return (
    <img
      src={src}
      alt={alt}
      className="h-7 w-auto object-contain sm:h-8"
      width={120}
      height={32}
    />
  );
}
